const getEnvironment = () => {
  // Vérifier directement si le mode est 'production'
  if (import.meta.env.MODE === 'production') {
    return 'production';
  }
  
  // Sinon retourner le mode actuel
  return import.meta.env.MODE;
};

export const APP_VERSION = {
  current: 'Version 2.0.4',
  name: 'Shopiweb Manager',
  releaseDate: '2024-12-12',
  environment: getEnvironment()
};
